import { render } from "./tableDetailCol.vue?vue&type=template&id=12b935d3&scoped=true"
import script from "./tableDetailCol.vue?vue&type=script&lang=js"
export * from "./tableDetailCol.vue?vue&type=script&lang=js"

import "./tableDetailCol.vue?vue&type=style&index=0&id=12b935d3&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b935d3"]])

export default __exports__